export const UriEnum = Object.freeze({
    search: "search",
    tags: "tags",
    directionFrom: "directionfrom",
    directionTo: "directionto",
    embedded: "embedded",
    marker: "marker",
    category: "category",
    data: "data",
    type: "type",
    weighting: "weighting",
    camera: "camera",
    isBackToResult: "isBackToResult",
});
